import { render, staticRenderFns } from "./ProductTour.vue?vue&type=template&id=9449f6ec"
import script from "./ProductTour.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTour.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports